import React from "react";
import { Table } from 'reactstrap';

export function TablaComentarios({ tipo, comentarios }) {
  return (
    <Table responsive={true} striped={true}>
      <thead>
        <tr><th colSpan={2} className="text-center">{ tipo }</th></tr>
      </thead>
      <tbody>
        {comentarios && comentarios.map((c, index) => {
          return <tr key={index}>
            <td className="font-weight-bold col-1">{ index+1 }.-</td>
            <td className="col-12">{c}</td>
          </tr>
        })}
      </tbody>
    </Table>
  );

}